import axios from 'axios';
import router from '../router';

const state = {
    lastNumber: 0,
};

const mutations = {
    SET_LAST_NUMBER(state, lastNumber) {
         state.lastNumber = lastNumber;
    },    
};

const actions = {
    async fetchLastNumber({ commit }) {
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }

        try {
        const response = await axios.get(`https://api.datafangst.dk/api/mortalin`, { headers: { Authorization: `Bearer ${userToken }` }, } );
        console.log(response.data);
        commit('SET_LAST_NUMBER', response.data);
        } catch (error) {
        console.error('Error fetching last number:', error);
        throw error; // Rethrow the error to handle it in the component
        }
    },
    
    async updateNumbers({commit}, { number, amount }) {
        console.log('Updating numbers:', number, amount);
        const userToken = localStorage.getItem('userToken'); 
        if (!userToken) {
            // Redirect to login page if token is not found
            router.push({ name: 'login' });
            return;
        }

        try {
          const response = await axios.put(`https://api.datafangst.dk/api/mortalin/1`, { number, amount }, { headers: { Authorization: `Bearer ${userToken }` }, } );
          console.log(response.data);
        } catch (error) {
          console.error('Error updating numbers:', error);
          throw error; // Rethrow the error to handle it in the component
        }
    },  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};